import {createSelector} from "reselect";

const baseData = (state) => state.tsdb;

export const getDashboards = createSelector(baseData, (data) => data.dashboards || []);
export const getDashboardCellsData = createSelector(
  baseData,
  (data) => data.dashboardCellsData || {}
);

export const getDashboardCells = createSelector(baseData, (data) => data.cells);

export const getWidgets = createSelector(baseData, (data) => data.widgets);
